import { render, staticRenderFns } from "./BaseInfoBlock.vue?vue&type=template&id=67e53ca0&scoped=true"
import script from "./BaseInfoBlock.vue?vue&type=script&lang=js"
export * from "./BaseInfoBlock.vue?vue&type=script&lang=js"
import style0 from "./BaseInfoBlock.vue?vue&type=style&index=0&id=67e53ca0&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.38_babel-core@7.0.0-bridge.0_@babel+core@7.29._923e00a32cb73abfd4273dbca1fa1c77/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e53ca0",
  null
  
)

export default component.exports